import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu, { MenuProps } from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Colors } from "../../utils/constants";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useDispatch, useSelector } from "react-redux";
import {
  updateAbdcGrade,
  updateSJRGrade,
  updateSort,
  updateSortName,
} from "../../store/slice/browseFilterSlice";
import Tooltip from "@mui/material/Tooltip";
import { usagelogApi } from "../../api/usageReportApi";
import { useAppSelector } from "../../store/hooks";
import { valueExistsBrowse } from "../../utils/helper";
import { IconButton } from "@mui/material";
import { Sort } from "@mui/icons-material";
import Popper from "@mui/material/Popper";
import Paper from "@mui/material/Paper";
import ClickAwayListener from "@mui/material/ClickAwayListener";

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    disablePortal
    container={document.body}
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

const SortByRelevenceForBrowser = ({
  selectedRankSort,
  packageDetails,
  sortData,
  abdcJournalData,
}: any) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  // const [selectedFilters.sortName, setSelectedSort] = React.useState("Journal");
  const [triggerEffect, setTriggerEffect] = React.useState(0);
  const consortiamaster_id = useAppSelector(
    (state) => state.customer.customerDetails?.consortiamaster_id,
  );

  const uniqueL1SubjectIds = [
    ...new Set(
      useAppSelector((state) => state.searchReducer.subjectL1Type) || [],
    ),
  ];

  const open = Boolean(anchorEl);

  const dispatch = useDispatch();
  const profileData = useSelector((state: any) => state?.login);

  const profileData1 = useSelector(
    (state: any) => state.customer.customerDetails,
  );
  const is_ONOSCustomer = useSelector(
    (state: any) => state.customer.customerDetails?.is_enable_onos,
  );

  const sortByABDCJournal =
    abdcJournalData?.find((item: Record<string, number>) =>
      item.hasOwnProperty("true"),
    )?.["true"] || 0;

  const selectedFilters = useAppSelector((state) => state.browseFilterSlice);

  const contextId =
    selectedFilters.collectionsValueJournal === "J-GateCollection"
      ? 1
      : selectedFilters.collectionsValueJournal === "Consortia Collections"
        ? 2
        : selectedFilters.collectionsValueJournal === "My Library Collections"
          ? 3
          : selectedFilters.collectionsValueJournal ===
              "MyPersonalLibraryCollection"
            ? 4
            : selectedFilters.collectionsValueJournal === "ONOS Collections"
              ? 5
              : selectedFilters.collectionsValueJournal === "Library OPAC"
                ? 6
                : selectedFilters.collectionsValueJournal ===
                    "Open Access Collections"
                  ? 7
                  : null;

  const logBasicSearchUsageData = (usageActionID: any, details?: any) => {
    const articleArticle_Id = details?.article_id ? details?.article_id : null;
    const articleResourcemaster_id = details?.resourcemaster_id
      ? details?.resourcemaster_id
      : null;
    const articleResourceissue_id = details?.resourceissue_id
      ? details?.resourceissue_id
      : null;
    const PackagePublisherId = details?.publisher_id
      ? details?.publisher_id[0]
      : null;
    const user_ipv4_address =
      sessionStorage.getItem("user_ipv4_address") || null;

    const userMasterId = profileData.user_id ? profileData.user_id : null;
    const informaticscustomerId = profileData.informaticscustomer_id
      ? profileData.informaticscustomer_id
      : null;
    const consortiamasterId =
      profileData1 && profileData1.consortiamaster_id
        ? profileData1.consortiamaster_id
        : null;
    const sessionKey = profileData.session_key ? profileData.session_key : null;
    const isONOS =
      is_ONOSCustomer &&
      selectedFilters.collectionsValueJournal === "ONOS Collections"
        ? 1
        : 0;
    usagelogApi(
      userMasterId,
      informaticscustomerId,
      consortiamasterId,
      usageActionID,
      contextId,
      null,
      articleArticle_Id,
      articleResourcemaster_id,
      PackagePublisherId,
      articleResourceissue_id,
      // profileData.ip_v4,
      user_ipv4_address,
      null,
      sessionKey,
      1,
      null,
      isONOS,
    );
  };
  const checkValue: any = useSelector(
    (state: any) => state.browseFilterSlice.sort,
  );
  // console.log("dta", checkValue);

  React.useEffect(() => {
    if (triggerEffect) onSearch();
  }, [triggerEffect]);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  async function handleSort(val: string) {
    setTriggerEffect((prev) => prev + 1);
    // if (val === "") {
    //   logBasicSearchUsageData(85, packageDetails);
    //   dispatch(updateSort(""));
    //   // setSelectedSort("Journal");
    //   dispatch(updateSortName("Journal"));

    if (val == "") {
      logBasicSearchUsageData(84, packageDetails);
      dispatch(updateSort("sjr_score desc"));
      dispatch(updateSortName("SJR"));
      dispatch(updateAbdcGrade(""));
    } else if (val === "resource_name_tk asc") {
      logBasicSearchUsageData(85, packageDetails);
      dispatch(updateSort("resource_name_tk asc"));
      // dispatch(updateSortName("Journal"));
      dispatch(updateSortName("Title"));
      dispatch(updateSJRGrade(""));
      dispatch(updateAbdcGrade(""));
    } else if (val === "Best Match") {
      // dispatch(updateSort("score desc"));
      // setSelectedSort("Best Match");
      dispatch(updateSortName("Best Match"));
      dispatch(updateSJRGrade(""));
      dispatch(updateAbdcGrade(""));
    } else if (val === "sjr_score desc") {
      logBasicSearchUsageData(84, packageDetails);
      // setSelectedSort("SJR");
      dispatch(updateSort("sjr_score desc"));
      dispatch(updateSortName("SJR"));
      dispatch(updateAbdcGrade(""));
    } else if (val === "sjr_hindex desc") {
      logBasicSearchUsageData(84, packageDetails);
      // setSelectedSort("H-Index");
      dispatch(updateSortName("H-Index"));
      dispatch(updateSort("sjr_hindex desc"));
      dispatch(updateSJRGrade(""));
      dispatch(updateAbdcGrade(""));
    } else if (val === "naas_value desc") {
      logBasicSearchUsageData(84, packageDetails);
      // setSelectedSort("NAAS");
      dispatch(updateSortName("NAAS"));
      dispatch(updateSort("naas_value desc"));
      dispatch(updateSJRGrade(""));
      dispatch(updateAbdcGrade(""));
    } else if (val === "abdc_ranking desc") {
      logBasicSearchUsageData(84, packageDetails);
      dispatch(updateSortName("ABDC"));
      dispatch(updateSort("abdc_ranking desc"));
      dispatch(updateSJRGrade(""));
    }

    // setSort(val);
    // let res = await getBrowserDetailsOnSort(val, getKeywords);
    // dispatch(browseJournalSearchResult(res));
    // let resourceIdList: string[] = [];
    // if (res?.docs) {
    //   res?.docs?.map((element: any) => {
    //     resourceIdList.push(element.resourcemaster_id);
    //   });
    // }
    // let response = await resourceSettingAlert(resourceIdList);
    // console.log("response", response);
    // dispatch(alertsAndFav(response));
    handleClose();
    // console.log("sortValue", getKeywords.setAlphabet);
  }

  async function onSearch() {
    // Make api req
    // dispatch(updateLoadingState(true));
    // let data = await search(searchReducer, selectedFilters, dispatch);
    // // Dispatch to redux
    // dispatch(updateSearchResults(data));
    // dispatch(updateLoadingState(false));
  }

  return (
    <div>
      <IconButton
        onClick={handleClick}
        sx={{
          display: {
            xs: "initial",
            sm: "initial",
            md: "none",
            lg: "none",
            xl: "none",
          },
        }}
      >
        <Sort />
      </IconButton>
      <Button
        style={{
          textAlign: "left",
          color: Colors.black,
          paddingTop: 0,
          paddingBottom: 0,
        }}
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="outlined"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{
          display: {
            xs: "none",
            sm: "none",
            md: "flex",
            lg: "flex",
            xl: "flex",
          },
        }}
      >
        <Button
          sx={{
            // fontSize: "0.8rem",
            color: Colors.black,
            // minHeight: 0,
            // padding: "5px 5px",

            fontFamily: "Helvetica Neue",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: { xs: 12, sm: 14, md: 14 },
            display: "flex",
            alignItems: "center",
          }}
        >
          Sort By
          <span style={{ fontSize: "0.8rem", paddingLeft: "6px" }}>
            {selectedFilters.sortName}
          </span>
        </Button>
      </Button>

      {/* <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          sx={{
            color: selectedFilters.sortName === "Journal" ? Colors.primary : "",
            fontSize: 14,
          }}
          onClick={() => handleSort("resource_name_tk asc")}
          disableRipple
        >
          Journal
        </MenuItem>
        {/* <Divider sx={{ my: 0.5 }} /> */}
      {/*{sortData?.length >= 1 ? (
          <div>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem
              sx={{
                color:
                  selectedFilters.sortName === "Ranking" ? Colors.primary : "",
                fontSize: 14,
                cursor: "default",
              }}
              //onClick={() => handleSort("Ranking")}
              disableRipple
            >
              Ranking
            </MenuItem>
          </div>
        ) : null}
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          // value={publicationValue}
          value={selectedFilters.sortName}
          // onChange={handleChange}
          sx={{ padding: 1 }}
        >
          {valueExistsBrowse("SJR", sortData) && (
            <Tooltip title="Scimago Journal Ranking">
              <FormControlLabel
                checked={checkValue === "sjr_score desc" ? true : false}
                sx={{
                  "& .MuiFormControlLabel-label": { fontSize: 14 },
                }}
                value="sjr_rank"
                control={<Radio />}
                label="SJR"
                // onChange={() => handleSort("sjr_score desc")}
                onChange={() => handleSort("")}
              />
            </Tooltip>
          )}
          {valueExistsBrowse("H-Index", sortData) && (
            <Tooltip title="Hirsch index">
              <FormControlLabel
                checked={checkValue === "sjr_hindex desc" ? true : false}
                sx={{
                  "& .MuiFormControlLabel-label": { fontSize: 14 },
                }}
                value="sjr_hindex desc"
                control={<Radio />}
                label="H-Index"
                onChange={() => handleSort("sjr_hindex desc")}
              />
            </Tooltip>
          )}
          {consortiamaster_id === 1874 &&
            valueExistsBrowse("NAAS", sortData) && (
              <Tooltip title="National Academy of Agricultural Sciences">
                <FormControlLabel
                  checked={checkValue === "naas_value desc" ? true : false}
                  sx={{
                    "& .MuiFormControlLabel-label": { fontSize: 14 },
                  }}
                  value="naas_value desc"
                  control={<Radio />}
                  label="NAAS"
                  onChange={() => handleSort("naas_value desc")}
                />
              </Tooltip>
            )}
          {sortByABDCJournal > 0 && (
            <Tooltip title="Australian Business Deans Council">
              <FormControlLabel
                checked={checkValue === "abdc_ranking desc" ? true : false}
                sx={{
                  "& .MuiFormControlLabel-label": { fontSize: 14 },
                }}
                value="abdc_ranking desc"
                control={<Radio />}
                label="ABDC"
                onChange={() => handleSort("abdc_ranking desc")}
              />
            </Tooltip>
          )}
        </RadioGroup>
      </StyledMenu> */}

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom"
        disablePortal={false}
        modifiers={[
          {
            name: "flip",
            enabled: false, // disables flipping to top
          },
          {
            name: "preventOverflow",
            enabled: true,
            options: {
              boundary: "viewport", // prevents it from going out of screen
              padding: 8,
            },
          },
          {
            name: "offset",
            options: {
              offset: [0, 8], // [horizontal, vertical] spacing
            },
          },
        ]}
        // sx={{ zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper
            sx={{
              mt: 1,
              minWidth: 180,
              boxShadow:
                "0px 4px 6px rgba(0,0,0,0.1), 0px 1px 3px rgba(0,0,0,0.05)",
              borderRadius: "8px",
              padding: 1,
            }}
          >
            <MenuItem
              sx={{
                color:
                  selectedFilters.sortName === "Title" ? Colors.primary : "",
                fontSize: 14,
              }}
              onClick={() => handleSort("resource_name_tk asc")}
              disableRipple
            >
              {/* Journal */}
              Title
            </MenuItem>

            {sortData?.length >= 1 && (
              <>
                <Divider sx={{ my: 0.5 }} />
                <MenuItem
                  sx={{
                    color:
                      selectedFilters.sortName === "Ranking"
                        ? Colors.primary
                        : "",
                    fontSize: 14,
                    cursor: "default",
                  }}
                  disableRipple
                >
                  Ranking
                </MenuItem>
              </>
            )}

            <RadioGroup
              aria-labelledby="sort-radio"
              name="sort-radio-group"
              value={selectedFilters.sortName}
              sx={{ padding: 1 }}
            >
              {valueExistsBrowse("SJR", sortData) && (
                <Tooltip title="Scimago Journal Ranking">
                  <FormControlLabel
                    checked={checkValue === "sjr_score desc"}
                    sx={{ "& .MuiFormControlLabel-label": { fontSize: 14 } }}
                    value="sjr_score desc"
                    control={<Radio />}
                    label="SJR"
                    onChange={() => handleSort("")}
                  />
                </Tooltip>
              )}

              {valueExistsBrowse("H-Index", sortData) && (
                <Tooltip title="Hirsch index">
                  <FormControlLabel
                    checked={checkValue === "sjr_hindex desc"}
                    sx={{ "& .MuiFormControlLabel-label": { fontSize: 14 } }}
                    value="sjr_hindex desc"
                    control={<Radio />}
                    label="H-Index"
                    onChange={() => handleSort("sjr_hindex desc")}
                  />
                </Tooltip>
              )}

              {(uniqueL1SubjectIds.includes(5) ||
                consortiamaster_id === 1874) &&
                valueExistsBrowse("NAAS", sortData) && (
                  <Tooltip title="National Academy of Agricultural Sciences">
                    <FormControlLabel
                      checked={checkValue === "naas_value desc"}
                      sx={{ "& .MuiFormControlLabel-label": { fontSize: 14 } }}
                      value="naas_value desc"
                      control={<Radio />}
                      label="NAAS"
                      onChange={() => handleSort("naas_value desc")}
                    />
                  </Tooltip>
                )}

              {sortByABDCJournal > 0 && (
                <Tooltip title="Australian Business Deans Council">
                  <FormControlLabel
                    checked={checkValue === "abdc_ranking desc"}
                    sx={{ "& .MuiFormControlLabel-label": { fontSize: 14 } }}
                    value="abdc_ranking desc"
                    control={<Radio />}
                    label="ABDC"
                    onChange={() => handleSort("abdc_ranking desc")}
                  />
                </Tooltip>
              )}
            </RadioGroup>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

export default SortByRelevenceForBrowser;
